import { Item } from '../type'

export const ProductPrice = ({ item, fallback = '' }: { item?: Pick<Item, 'price' | 'originalPrice' | 'isDiscounted'>, fallback?: string }) => {
    const discounted = item?.isDiscounted && item.originalPrice && item.price

    return (
        <span style={{ display: 'inline-flex', flexWrap: 'wrap', alignItems: 'baseline', gap: '0.35em' }}>
            {discounted && <del style={{ color: '#767676', fontWeight: 400 }}>{item.originalPrice}</del>}
            <span style={discounted ? { color: '#000000' } : undefined}>{item?.price ?? fallback}</span>
        </span>
    )
}
